var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"type":_vm.type,"text":_vm.file.name,"link":_vm.computedLink,"target":"_blank"}})}
var staticRenderFns = []

export { render, staticRenderFns }